var Slider = (function () {

    var $ = require('jquery');
    var self = {};

    self.$connectionsSwiper = $('.ce-connections');
    self.$endorsementSwiperText = $('.ce-endorsement-slider--text');
    self.$endorsementSwiperImageCarrousel = $('.ce-endorsement-slider--image-carrousel');
    self.$featuredEndorsementsSwiper = $('.ce-featured-endorsements');
    self.$timelineSwiper = $('.ce-timeline');

    self.init = function () {

        self.connectionsSlider();
        self.endorsementSliderText();
        self.endorsementSliderImageCarousel();
        self.featuredEndorsementsSlider();
        self.timelineSlider();

    };

    self.connectionsSlider = function () {

        if (self.$connectionsSwiper.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            self.$connectionsSwiper.each(function () {

                new Swiper($(this).find('.swiper-container')[0], {
                    breakpoints: {
                        1024: {
                            slidesPerGroup: 2,
                            slidesPerView: 2,
                        }
                    },
                    loop: true,
                    navigation: {
                        nextEl: $(this).find('.swiper-button-next')[0],
                        prevEl: $(this).find('.swiper-button-prev')[0]
                    },
                    slidesPerGroup: 4,
                    slidesPerView: 4,
                    spaceBetween: 25,
                    speed: 900,
                    watchOverflow: true
                });

            });

        }

    };

    self.endorsementSliderText = function () {

        if (self.$endorsementSwiperText.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            self.$endorsementSwiperText.each(function () {

                new Swiper($(this).find('.swiper-container')[0], {
                    breakpoints: {
                        767: {
                            pagination: {
                                el: $(this).find('.swiper-pagination')[0]
                            }
                        }
                    },
                    navigation: {
                        nextEl: $(this).find('.swiper-button-next')[0],
                        prevEl: $(this).find('.swiper-button-prev')[0]
                    },
                    watchOverflow: true
                });

            });

        }

    };

    self.endorsementSliderImageCarousel = function () {

        if (self.$endorsementSwiperImageCarrousel.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            var amountOfSlides = $(self.$endorsementSwiperImageCarrousel).find('.swiper-container--thumbs .swiper-slide ').length;

            self.$endorsementSwiperImageCarrousel.each(function () {

                var galleryThumbs = new Swiper($(this).find('.swiper-container--thumbs')[0], {
                        breakpoints: {
                            767: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },

                        },
                        virtualTranslate : false,
                        spaceBetween: 10,
                        centeredSlides: true,
                        slidesPerView: 5,
                        touchRatio: 0.2,
                        slideToClickedSlide: true,
                        loop: false,
                        loopedSlides: 1,
                        watchOverflow: true,
                        simulateTouch: true,
                        autoplay: false,
                        noSwiping: true,
                        allowTouchMove: false,
                        initialSlide : Math.floor(amountOfSlides /2),

                });

                var galleryContent = new Swiper($(this).find('.swiper-container--content')[0], {
                    breakpoints: {
                        767: {
                            pagination: {
                                el: $(this).find('.swiper-pagination')[0]
                            }
                        }
                    },
                    navigation: {
                        nextEl: $(this).find('.image-carousel-button-next')[0],
                        prevEl: $(this).find('.image-carousel-button-prev')[0]
                    },
                    loop: false,
                    loopedSlides:  1,
                    watchOverflow: true,
                    autoplay: false,
                    initialSlide : Math.floor(amountOfSlides /2),
                    simulateTouch: true

                });

                galleryContent.controller.control = galleryThumbs;
                galleryThumbs.controller.control = galleryContent;

            });


        }

    };

    self.featuredEndorsementsSlider = function () {

        if (self.$featuredEndorsementsSwiper.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            self.$featuredEndorsementsSwiper.each(function () {

                new Swiper($(this).find('.swiper-container')[0], {
                    breakpoints: {
                        767: {
                            slidesPerView: 1
                        }
                    },
                    navigation: {
                        nextEl: $(this).find('.swiper-button-next')[0],
                        prevEl: $(this).find('.swiper-button-prev')[0]
                    },
                    slidesPerView: 'auto',
                    spaceBetween: 25,
                    watchOverflow: true
                });

            });

        }

    };

    self.timelineSlider = function () {

        if (self.$timelineSwiper.length > 0) {

            const Swiper = require('./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js');

            self.$timelineSwiper.each(function () {

                var paginationSwiper = new Swiper($(this).find('.pagination-swiper')[0], {
                    breakpoints: {
                        767: {
                            navigation: {
                                nextEl: $(this).find('.swiper-button-next')[0],
                                prevEl: $(this).find('.swiper-button-prev')[0]
                            },
                            spaceBetween: 52,
                            slidesPerView: 1,
                            touchRatio: 1
                        }
                    },
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    slideToClickedSlide: true,
                    watchOverflow: true,
                    touchRatio: 0.2
                });

                // 52 is the box-shadow size (blur and spread together * 2)
                var contentSwiper = new Swiper($(this).find('.content-swiper')[0], {
                    effect: 'fade',
                    spaceBetween: 52,
                    speed: 500
                });

                contentSwiper.controller.control = paginationSwiper;
                paginationSwiper.controller.control = contentSwiper;

            });

        }

    };

    return self;

}());

module.exports = Slider;
